import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { DEFAULT_PRIMARY_FONT_FAMILY } from 'theme/fontDefaults';

export const StContainer = styled(Grid)(({ theme }) => ({
  color: theme.palette.neutral8.main,
}));

export const StLastUpdatedLabel = styled(Grid)(({ theme }) => ({
  fontFamily: `${theme?.palette?.primaryFontFamilyType || DEFAULT_PRIMARY_FONT_FAMILY}, sans-serif`,
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '14px',
  color: '#5E5E5E',
}));

export const StDropDown = styled(Grid)(() => ({
  '& .MuiSelect-select': {
    whiteSpace: 'normal !important',
  },
}));
